// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FilterIcon = (props: any) => {
  const { fill = false } = props
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      //fill="none"
      xmlns="http://www.w3.org/2000/svg"
      fill={fill ? '#1890FF' : 'none'}
    >
      <path
        d="M11.4451 2H2.55491C2.31645 2 2.17331 2.26477 2.3039 2.4643L5.58737 7.48071C5.61934 7.52955 5.63636 7.58664 5.63636 7.64501V11.7C5.63636 11.8657 5.77068 12 5.93636 12H8.06364C8.22932 12 8.36364 11.8657 8.36364 11.7V7.64501C8.36364 7.58664 8.38066 7.52954 8.41263 7.48071L11.6961 2.4643C11.8267 2.26478 11.6835 2 11.4451 2Z"
        stroke={fill ? '#1890FF' : '#9B9B9B'}
        strokeWidth="1.5"
        strokeLinecap="round"
        fillOpacity={fill ? '1' : '0'}
      />
    </svg>
  )
}
